import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import _ from "lodash";
import axios from "axios";
import swal from 'sweetalert2';
import {Modal, InputBase, FormControl, InputAdornment} from '@material-ui/core';

import {selectedNotes} from "../../../../../../actions/visits_actions";
import {tokenHeader} from "../../../../../../utils/headers";
import {ajaxHandler} from "../../../../../../utils/errors";
import helpers from "../../../../../../utils/helpers";
import urls from "../../../../../../utils/urls";

import share from '../../../../../../assets/share.png';
import cross from '../../../../../../assets/cross.png';
import './styles.scss';
import LoadingSpinner from "../../../../../../components/spinner/Spinner";

class ShareModal extends Component {

    constructor(props) {
        super(props);

        let emails = [];
        let station = _.find(this.props.stations.list, (station) => station.id === this.props.stations.selectedStation);
        if (station && station.company && station.company.emails) {
            emails = station.company.emails.split(";").map(mail => mail.toLowerCase().trim()).filter(mail => mail !== '');
        }
        this.state = {
            emails,
            newEmail: '',
            showEmailPreview: false,
            xhr: false,
            emailPreview: ''
        }
    }

    _getNotes = () => {
        let notes = [];
        if (this.props.type === "selected") {
            if (this.props.visits.notes && this.props.visits.selectedNotesIds) {
                notes = this.props.visits.notes.filter(note => this.props.visits.selectedNotesIds.indexOf(note.id) > -1)
            }
        }
        else {
            notes = [this.props.notes.noteToEdit];

        }
        console.log(notes);
        return notes;
    };

    renderNotes = () => {
        let notes = this._getNotes();
        return notes.map(note => {
                return (<div key={note.id.toString()} className={"note"}>
                    <img src={cross} className={"cross"} alt={"close"} onClick={() => this.removeNote(note.id)}/>
                    <div className={"title"}>{note.title}</div>
                    <div className={"description"}>{note.public_comment}</div>
                </div>)
            }
        )
    };

    renderMails = () => {
        let {emails} = this.state;
        return emails.map((email, i) => {
                return (
                    <div key={i} className={"email-container"}>
                        <div className={'email-detail'}>{email}</div>
                        <div className={'email-action'}
                             onClick={() => this.removeEmail(i)}
                        >
                            <i className="material-icons">close</i>
                        </div>
                    </div>
                );
            }
        )
    };

    removeEmail = (index) => {
        let emails = [...this.state.emails];
        emails.splice(index, 1);
        this.setState({emails});
    };

    removeNote = (id) => {
        let filteredNotes = _.filter(this.props.visits.selectedNotesIds, (note) => {
            return note !== id.toString()
        });
        if (filteredNotes.length === 0) {
            this.props.cancel();
        }
        this.props.selectedNotes(filteredNotes);
    };

    handleInputChange = (ev) => {
        this.setState({newEmail: ev.target.value});
    };

    addEmail = () => {
        let {newEmail} = this.state;
        if (helpers.isValidEmail(newEmail)) {
            let emails = [...this.state.emails];
            emails.push(newEmail.toLowerCase());
            this.setState({
                newEmail: '',
                emails
            });
        }
    };

    shareNotes = (notesSelected) => {

        if (this.state.emails.length === 0) return false;
        let notes = "";

        notesSelected.forEach((note, index) => {
            if (index === notesSelected.length - 1) {
                notes += note.id;
            } else {
                notes += note.id + ",";
            }
        });


        let data = {
            mails: this.state.emails.toString(),
            notes,
            send_email: this.state.showEmailPreview
        };

        this.setState({xhr: true});
        const share_url = `${urls.API_ROOT}/api/v1/share-station-notes/`;
        axios
            .post(share_url, data, tokenHeader())
            .then((response) => {
                    if (this.state.showEmailPreview) {
                        let text = this.props.visits.selectedNotesIds.length > 1 ? "Notas compartidas correctamente" : "Nota compartida correctamente";
                        swal({
                            title: `${text}`,
                            text: "",
                            type: 'success',
                            showConfirmButton: false,
                            showCancelButton: false,
                            timer: 3000
                        });
                        this.setState({xhr: false});
                        this.props.cancel();
                    } else {
                        this.setState({emailPreview: {__html:response.data.html}, showEmailPreview: true, xhr:false});
                    }

                }
            )
            .catch(e => {
                this.setState({xhr: false});
                ajaxHandler(e);
            });
    };

    renderModalSection = () => {
        if (this.state.showEmailPreview) {
            console.log(this.state.html);
            return (<div className="email-html" dangerouslySetInnerHTML={this.state.emailPreview}/>)
        } else {
            return (<div>
                <div className={"notes-section"}>
                    {this.renderNotes()}
                </div>
                <div className={"send-email-text"}>ENVIAR POR MAIL</div>
                <div className={'emails-section'}>{this.renderMails()}</div>
                <div className={"email-form"}>
                    <FormControl fullWidth className={"new-email-form"}>
                        <InputBase className={"outlined-input"}
                                   onKeyPress={(ev) => {
                                       console.log(`Pressed keyCode ${ev.key}`);
                                       if (ev.key === 'Enter') {
                                           // Do code here
                                           ev.preventDefault();
                                           this.addEmail();
                                       }
                                   }}
                                   startAdornment={
                                       <InputAdornment position="start" onClick={this.addEmail}>
                                           <i className="material-icons">add</i>
                                       </InputAdornment>
                                   }
                                   value={this.state.newEmail}
                                   onChange={this.handleInputChange}
                                   placeholder={"Agregar correo"}/>
                    </FormControl>
                </div>
            </div>);
        }
    };

    render() {
        let notes = this._getNotes();
        let items_text = notes.length > 1 ? `(${notes.length} ITEMS)` : `(${notes.length} ITEM)`;
        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.props.open}
                onClose={this.props.cancel}
            >
                <div className="share-modal-section">
                    <img src={cross} onClick={this.props.cancel} className={"cross"} alt={"close"}/>
                    <div className={"title-section"}>
                        <img src={share} alt={"share"} className={"share"}/>
                        <div className="text">Compartir</div>
                        <div className="items">{items_text}</div>
                    </div>
                    {this.renderModalSection()}
                    <div className="text-center btns">
                        {!this.state.xhr && this.state.showEmailPreview &&
                        <div>
                            <div className="btn-cancel" onClick={this.props.cancel}>Cancelar</div>
                            <div className="btn-accept" onClick={() => this.shareNotes(notes)}>Enviar</div>
                        </div>
                        }
                        {!this.state.xhr && !this.state.showEmailPreview &&
                        <div>
                            <div className="btn-cancel" onClick={this.props.cancel}>Cancelar</div>
                            <div className="btn-accept" onClick={() => this.shareNotes(notes)}>Previsualizar</div>
                        </div>
                        }
                        {this.state.xhr &&
                        <LoadingSpinner width={50}/>
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        visits: state.visits,
        stations: state.stations,
        notes: state.notes_actions
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({selectedNotes}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareModal);


// WEBPACK FOOTER //
// ./src/containers/site-visits/common/actionButtons/components/shareModal/ShareModal.js